import React, { PureComponent } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import './label.scss';

class Label extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    htmlFor: PropTypes.string,
    text: PropTypes.any,
  };

  render() {
    return (
      <label
        className={cx('text-sm cursor-pointer select-none', this.props.className)}
        htmlFor={this.props.htmlFor}>
        {this.props.text}
      </label>
    );
  }
}

export default  Label;
